var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShopfloFooter = function SvgShopfloFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9F9FA9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#shopflo-footer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.482 4.138 4.784 9.832a2.804 2.804 0 0 1-3.963 0 2.8 2.8 0 0 1 0-3.961l3.716-3.714a2.804 2.804 0 0 1 3.963 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.482 4.138 4.784 9.832a2.804 2.804 0 0 1-3.963 0 2.8 2.8 0 0 1 0-3.961l3.716-3.714a2.804 2.804 0 0 1 3.963 0zM2.83 15.27l5.698-5.695a2.804 2.804 0 0 1 3.964 0 2.8 2.8 0 0 1 0 3.961L8.776 17.25a2.804 2.804 0 0 1-3.963 0L2.83 15.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.83 15.27 5.698-5.695a2.804 2.804 0 0 1 3.964 0 2.8 2.8 0 0 1 0 3.961L8.776 17.25a2.804 2.804 0 0 1-3.963 0L2.83 15.27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.97 4.815c3.05 0 4.808 2.317 4.808 5.391 0 3.137-1.97 5.453-4.914 5.453-1.44 0-2.498-.569-3.007-1.264v5.012h-2.816V5.647l2.151-.474.58 1.138c.466-.8 1.631-1.496 3.199-1.496m-34.603-.084c2.965 0 3.96 1.874 4.088 2.99l-2.35.526c-.085-.61-.53-1.39-1.716-1.39-.742 0-1.334.443-1.334 1.033 0 .505.38.821.953.926l1.482.316c2.054.421 3.092 1.664 3.092 3.18 0 1.684-1.313 3.41-4.045 3.41-3.134 0-4.215-2.021-4.342-3.2l2.414-.527c.064.821.678 1.58 1.906 1.58.932 0 1.377-.485 1.377-1.032 0-.463-.318-.842-1.123-1.01l-1.376-.316c-2.012-.442-2.922-1.643-2.922-3.096 0-1.853 1.651-3.39 3.896-3.39m21.833 0c3.113 0 5.464 2.295 5.464 5.496 0 3.179-2.35 5.496-5.464 5.496-3.113 0-5.464-2.317-5.464-5.496 0-3.2 2.351-5.495 5.464-5.496m35.328 0c3.113 0 5.464 2.295 5.464 5.496 0 3.179-2.35 5.496-5.464 5.496-3.113 0-5.464-2.317-5.464-5.496 0-3.2 2.351-5.496 5.464-5.496m-48.712 1.18c.678-.8 1.821-1.138 2.817-1.138 2.647 0 3.876 1.832 3.876 4.106v6.527H33.69V9.363c0-1.158-.571-2.063-1.927-2.063-1.185 0-1.884.884-1.948 2.021v6.085H27V.723l2.817-.708zM67.76.46h-.001v2.018h-1.192c-.635 0-1.462.273-1.462 1.431v1.137h2.189v2.67h-2.189v7.69h-2.837V3.867c0-2.333 1.478-3.849 3.78-3.853V0h1.712zm3.92 14.945h-2.816V.656L71.68.015zM43.2 7.28c-1.376 0-2.646.99-2.646 2.948 0 1.937 1.27 2.948 2.646 2.948 1.377 0 2.647-.99 2.647-2.948 0-1.959-1.27-2.948-2.647-2.948m35.328 0c-1.376 0-2.647.99-2.647 2.948 0 1.937 1.27 2.948 2.647 2.948s2.648-.99 2.648-2.948c0-1.959-1.271-2.948-2.648-2.948m-23.108.042c-1.44 0-2.605 1.074-2.605 2.906 0 1.831 1.165 2.926 2.605 2.926s2.584-1.074 2.584-2.926c0-1.832-1.144-2.906-2.584-2.906"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shopflo-footer_svg__a",
    width: 13.313,
    height: 16.733,
    x: 0,
    y: 1.337,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1639_24906"
  })))));
};
export default SvgShopfloFooter;